// @flow strict

import * as React from 'react';
import cx from 'classnames';
import styles from './styles.scss';
import PageContentBlock from '../../internal/PageContentBlock';
import LazyLoadImage from '../../internal/LazyLoadImage';

type PropTypes = {|
  title: string,
  titleImage?: string,
  subtitle?: string,
  children?: React.Node,
  image?: string,
  variant: 'Default' | 'Dark',
|};

const Header = (props: PropTypes) => {
  return (
    <PageContentBlock className={styles.content} image={props.image} background={props.variant}>
      <div
        className={cx(
          styles.container,
          props.image && styles.isShort,
          props.variant === 'Dark' && styles.isLeftHeader,
        )}
      >
        {props.subtitle && (
          <p
            className={
              props.titleImage || props.image || props.variant === 'Dark'
                ? styles.subtitleInDarkBg
                : styles.subtitle
            }
          >
            {props.subtitle}
          </p>
        )}
        {props.titleImage && (
          <h1 className={styles.title}>
            <LazyLoadImage
              src={props.titleImage}
              alt={props.title}
              className={styles.titleImage}
              defaultSize={{ height: 60, width: 250 }}
            />
            <span className={styles.visuallyhidden}>{props.title}</span>
          </h1>
        )}
        {!props.titleImage && <h1 className={styles.title}>{props.title}</h1>}
        {props.children && <p className={styles.text}>{props.children}</p>}
      </div>
    </PageContentBlock>
  );
};

Header.defaultProps = {
  variant: 'Default',
};

export default Header;
